import Cookie from '@/helpers/cookie'

const states = {
  token: new Cookie({ name: 'jwt-login' }),
  roles: [],
  details: {},
  rolesUser: ''
}

export default states



// WEBPACK FOOTER //
// ./src/store/modules/users/state.js